export default __webpack_public_path__ + "static/audiogamehighlight-0dce48ad3fe46e1c4cc43b5a575b52b4.png";